import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  TemplateRef,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { HlmCardImports } from '@spartan-ng/helm/card';

@Component({
  selector: 'app-kpi-card',
  standalone: true,
  imports: [NgTemplateOutlet, HlmCardImports],
  templateUrl: './kpi-card.component.html',
  // The host is the grid/flex item, so it has to fill its cell before the inner
  // h-full means anything. Without this, cards with a subtext end up taller.
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block h-full' },
})
export class KpiCardComponent {
  @Input() label = '';
  @Input() value = '';
  @Input() subtext?: string;
  /** 'indigo' highlights the figure in the brand color, 'default' keeps it neutral. */
  @Input() accent: 'indigo' | 'default' = 'indigo';
  /**
   * KPI values are numbers almost everywhere, and numbers read best flush right
   * under the icon. Set 'start' for the rare card that shows a name or label.
   */
  @Input() align: 'start' | 'end' = 'end';

  @ContentChild('icon') iconTemplate?: TemplateRef<unknown>;

  get valueClass(): string {
    return this.accent === 'indigo' ? 'text-primary' : 'text-foreground';
  }
}
